import React, { Component } from 'react'
import qs from 'qs'
import axios from 'axios'
import { Formik, Form, Field } from 'formik';

class SignIn extends Component {
  
  state = {
    isLoading: false,
  }
  
  render() {
    return (
      <div class="d-flex flex-column flex-root">
        <div class="login login-3 wizard d-flex flex-column flex-lg-row flex-column-fluid">
          <div class="login-content flex-row-fluid d-flex flex-column p-10">
            <div class="text-right d-flex justify-content-center">
              <div class="top-signin text-right d-flex justify-content-end pt-5 pb-lg-0 pb-10">
                <span class="font-weight-bold text-muted font-size-h6">Neu hier?</span>
                <a href="#/register" class="font-weight-bold text-primary font-size-h6 ml-2">Registrierung</a>
              </div>
            </div>
            <div class="d-flex flex-row-fluid flex-center">
              <div class="login-form">
                <div class="pb-5 pb-lg-15">
                  <h4 class="text-muted font-weight-bold font-size-h4">Pivicon ID</h4>
                  <h3 class="font-weight-bolder text-dark font-size-h2 font-size-h1-lg">Anmeldung</h3>
                </div>
                <Formik
                  initialValues={{ username: '', password: '' }}
                  validateOnChange={false}
                  validateOnBlur={false}
                  validate={values => {
                    const errors = {};
                    if (!values.username) {
                      errors.username = true;
                    }
                    if (!values.password) {
                      errors.password = true;
                    }
                    return errors;
                  }
                  }
                  onSubmit={(values, { setSubmitting, setFieldError }) => {
                    this.setState({ isLoading: true })

                    axios({
                      method: 'POST',
                      headers: { 'content-type': 'application/x-www-form-urlencoded' },
                      data: qs.stringify({
                        'grant_type': 'password',
                        'client_id': 'reactclient',
                        'client_secret': 'reactclient',
                        'username': values.username,
                        'password': values.password
                      }),
                      url: process.env.REACT_APP_OAUTH_GATEWAY_URL
                    }).then(response => {
                        this.setState({ isLoading: false })
                        setSubmitting(false)
                        if (response.status === 200) {
                          if(this.props.redirect !== undefined) {
                            const url = this.props.oauth + '?redirect=' + encodeURIComponent(this.props.redirect) + 
                                                           '&access_token=' + response.data.access_token + 
                                                           '&refresh_token=' + response.data.refresh_token + 
                                                           '&expires_in=' + response.data.expires_in;

                            window.location.href = url
                          }
                        }
                      })
                      .catch(error => {
                        if (error.response.status === 401) {
                          setFieldError('username', true);
                          setFieldError('password', true);
                        }
                      })
                  }}
                >
                  {({ errors, isSubmitting }) => (
                    <Form class="kt-form">
                      <div class="form-group">
                        <label class="font-size-h5 font-weight-bolder text-dark">E-Mail</label>
                        <Field type="text" name="username" class={errors.username ? "form-control h-auto py-6 rounded-lg border-danger is-invalid" : "form-control h-auto py-6 rounded-lg border-1"} autocomplete="off" />
                      </div>
                      <div class="form-group">
                        <div class="d-flex justify-content-between mt-n5">
                          <label class="font-size-h5 font-weight-bolder text-dark pt-5">Passwort</label>
                          <a href="#/forgot" class="font-weight-bold text-primary font-size-h6 pt-5" tabindex="-1">Passwort vergessen?</a>
                        </div>
                        <Field type="password" name="password" class={errors.password ? "form-control h-auto py-6 rounded-lg border-danger is-invalid" : "form-control h-auto py-6 rounded-lg border-1"} autocomplete="off" />
                      </div>
                      <div class="pb-lg-0 pb-5">
                        {
                          this.state.isLoading
                            ? <button type="submit" id="kt_login_singin_form_submit_button" class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-3 spinner spinner-right spinner-white pr-15" disabled={isSubmitting}>Anmelden</button>
                            : <button type="submit" id="kt_login_singin_form_submit_button" class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-3" disabled={isSubmitting}>Anmelden</button>
                        }
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default SignIn;